import {useTranslation} from 'react-i18next'
import {SegmentedToggle} from '@/components/cartera/price-form-controls'
import {SectionCard} from '@/components/section-card'
import {Hint} from '@/components/ui/hint'
import {useUpdatePartnerBillingCycleAdmin, type Partner} from '@/hooks/inci/aliados/use-partners'
import type {BillingCycle} from '@/hooks/inci/cartera/use-cartera'

const CYCLES: BillingCycle[] = ['mensual', 'anual']

export function CicloSection({partner}: {partner: Partner}) {
  const {t} = useTranslation()
  const update = useUpdatePartnerBillingCycleAdmin(partner.user_id)

  return (
    <SectionCard
      title={t('partnerDetail.billing.cicloPreferido')}
      bodyClassName="space-y-2 px-5 py-4"
      testId="partner-detail-ciclo-preferido">
      <SegmentedToggle
        value={partner.billing_cycle_preferido}
        options={CYCLES}
        optionLabel={(c) => t(`cartera.precios.${c}`)}
        onChange={(cycle) => update.mutate(cycle)}
        testId="partner-detail-ciclo-preferido-toggle"
      />
      <Hint>{t('partnerDetail.billing.cicloPreferidoHint')}</Hint>
    </SectionCard>
  )
}
